import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { observer } from 'mobx-react-lite';
import moment from 'moment';
import { ReactElement, useState } from 'react';
import ReactDatePicker from 'react-datepicker';
import { NavigationButton } from '../../buttons/NavigationButton';
import { IDatePickerProps } from '../DayPicker';

export const MonthPicker = observer((props: IDatePickerProps): ReactElement => {
  const { selectedDate, onSetDate, minDate, maxDate, onClickNext, onClickPrevious, canClickNext, canClickPrevious } = props;

  const [isOpen, setIsOpen] = useState(false);
  const toggle = (): void => {
    setIsOpen((prevState) => !prevState);
  };

  const onChange = async (date: Date | null): Promise<void> => {
    if (date) {
      await onSetDate(date);
      toggle();
    }
  };

  const renderLabel = (): ReactElement => (
    <div
      className='date-label-container'
      onClick={toggle}
    >
      <div>
        <label
          className='selected-date'
          onClick={toggle}
        >
          {moment(selectedDate).format('MMMM yyyy')}
        </label>
      </div>
      <FontAwesomeIcon
        icon={isOpen ? faAngleUp : faAngleDown}
        onClick={toggle}
      />
    </div>
  );

  return (
    <div className='date-range-field month-picker'>
      <NavigationButton
        onClick={() => {
          void onClickPrevious();
        }}
        disabled={!canClickPrevious}
        left
      />
      <div>
        <ReactDatePicker
          onClickOutside={toggle}
          selected={selectedDate}
          onChange={(date) => {
            void onChange(date);
          }}
          dateFormat='MMMM yyyy'
          showMonthYearPicker
          open={isOpen}
          customInput={renderLabel()}
          minDate={minDate}
          maxDate={maxDate}
          calendarStartDay={1}
          disabledKeyboardNavigation
        />
      </div>
      <NavigationButton
        onClick={() => {
          void onClickNext();
        }}
        disabled={!canClickNext}
      />
    </div>
  );
});
